import { useQuery } from '@tanstack/react-query'
import { PartyPublicHeader } from '@/components/party/PartyPublicHeader'
import { PartyIdeologySection } from '@/components/party/PartyIdeologySection'
import { PartyPublicStats } from '@/components/party/PartyPublicStats'
import { PublicCandidatesSection } from '@/components/party/PublicCandidatesSection'
import { fetchProfile } from '@/services/profiles'
import type { PartyWithDetails } from '@/types'

interface PartyProfileProps {
  party: PartyWithDetails
}

export default function PartyProfile({ party }: PartyProfileProps) {
  // Fetch owner's profile to get username
  const { data: ownerProfile } = useQuery({
    queryKey: ['profile', party.user_id],
    queryFn: () => fetchProfile(party.user_id),
    enabled: !!party.user_id,
  })

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto max-w-4xl py-8 px-4">
        <div className="space-y-6">
          {/* Header */}
          <PartyPublicHeader
            party={party}
            nationName={party.nation.name}
            nationId={party.nation.id}
            ownerUsername={ownerProfile?.username ?? undefined}
          />

          {/* Ideology Section - full width */}
          <PartyIdeologySection ideology={party.ideology_vector} />

          {/* Stats grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Electoral Standing */}
            <PartyPublicStats />

            {/* Candidates */}
            <PublicCandidatesSection
              candidateCount={0}
              partyLeaderName={undefined}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
